module.exports = __webpack_public_path__ + "img/image-card-03.5dff2042.png";